var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6271 8.14735C14.6271 4.57556 11.7185 1.66699 8.1467 1.66699C4.57491 1.66699 1.66634 4.57556 1.66634 8.14735C1.66634 11.7191 4.57491 14.6277 8.1467 14.6277C9.69844 14.6277 11.1211 14.0835 12.2374 13.1696L17.4015 18.3337L18.333 17.4021L13.169 12.2381C14.0828 11.1217 14.6271 9.69909 14.6271 8.14735ZM2.96241 8.14735C2.96241 5.27675 5.2761 2.96306 8.1467 2.96306C11.0173 2.96306 13.331 5.27675 13.331 8.14735C13.331 11.0179 11.0173 13.3316 8.1467 13.3316C5.2761 13.3316 2.96241 11.0179 2.96241 8.14735Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.b2678fc6dda29481144e18aa61d243e8.svg";
export { ForwardRef as ReactComponent };